function uniquePersonsAtRiskOptions({
  otherOption,
  personsAtRiskOptions,
  selectedPersonsAtRisk = [],
}) {
  const selectedValues = selectedPersonsAtRisk.reduce((acc, person) => {
    if (person.value !== otherOption.value) acc.push(person.value);

    return acc;
  }, []);

  const optionsSet = new Set([...personsAtRiskOptions, ...selectedValues]);

  const formattedValues = Array.from(optionsSet).map((person) => ({
    label: person,
    name: person,
    value: person,
  }));

  formattedValues.push(otherOption);

  return formattedValues;
}

function formatPersonsAtRiskValues(personsAtRisk) {
  return personsAtRisk.map((personAtRisk) => {
    const {
      attributes: { name },
      id,
    } = personAtRisk;

    return {
      id,
      isSelected: true,
      key: name,
      label: name,
      name,
      value: name,
    };
  });
}

const updatedPersonsAtRiskValues = (initialArray, updatedArray) => {
  if (initialArray.length === 0) return updatedArray;

  const collectedAllNameValues = [];

  const initialValuesIncludingDestroyKey = initialArray.reduce(
    (accumulator, currentValue) => {
      collectedAllNameValues.push(currentValue.name);

      if (updatedArray.find((newObj) => newObj.name === currentValue.name)) {
        accumulator.push(currentValue);
      } else {
        const duplicateObj = { ...currentValue };
        duplicateObj._destroy = '1';
        accumulator.push(duplicateObj);
      }

      return accumulator;
    },
    [],
  );

  const newValues = updatedArray.filter(
    (obj) =>
      !collectedAllNameValues.includes(obj.name) &&
      !obj.id &&
      obj.name !== undefined,
  );

  return [...initialValuesIncludingDestroyKey, ...newValues];
};

const defaultCoshhDocument = {
  id: null,
  title: '',
  reference: '',
  quantityOnSite: '',
  quantityToBeUsed: '',
  substanceQuantityPerDay: '',
  uses: '',
  staffNumber: '',
  personsAtRisk: [],
  personsAtRiskOther: '',
  workerExposureTime: '',
  exposureFrequency: '',
  exposureFrequencyOther: '',
  location: '',
  levelOfRisk: '',
  additionalInformation: '',
  longTermExposureLimit: '',
  shortTermExposureLimit: '',
  manufacturer: '',
};

export {
  uniquePersonsAtRiskOptions,
  formatPersonsAtRiskValues,
  updatedPersonsAtRiskValues,
  defaultCoshhDocument,
};
